import { BasePortfolio, WebUserDataConstants, WweBenchmark } from '@ddt-web/domain';

import { EngagementsFlags } from './engagements-flags.model';


export class BpasEngagement {
	public readonly applications: Array<string> = [WebUserDataConstants.APPLICATIONS.BPAS];
	public readonly origin: string = WebUserDataConstants.APPLICATIONS.BPAS_PAC;
	public readonly type: string = WebUserDataConstants.TYPE.PREFERENCE;

	constructor(
		public readonly children: BasePortfolio[],
		public readonly description: string,
		public readonly flags: EngagementsFlags,
		public readonly currency: string,
		public readonly uniqueId?: string,
		public readonly dateLastModified?: string,
		public readonly currentUserIsOwner?: boolean,
		public readonly benchmarkDetails?: WweBenchmark,
		public readonly lastModifiedDisplayDate?: string
	) { }
}

// type guard required as the engagementPortfolio object used in analysis does not seem to get created in the constructor
// as a result, some of the fields you would expect are missing too e.g. applications
// this check, while not comprehensive, is sufficient to differentiate it from the APB engagement 
export const isBpasEngagement = (engagementPortfolio: any): engagementPortfolio is BpasEngagement => {
	return engagementPortfolio.origin === WebUserDataConstants.APPLICATIONS.BPAS_PAC &&
		engagementPortfolio.type === WebUserDataConstants.TYPE.PREFERENCE;
};
